import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import toast from 'react-hot-toast';

interface CopyableInputFieldProps {
  label?: string;
  value: string;
  className?: string;
  helperText?: string;
  id?: string;
}

export default function CopyableInputField({
  label,
  value,
  className = '',
  helperText,
  id,
}: CopyableInputFieldProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success('Copied to clipboard!');
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy');
    }
  };

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          type="text"
          value={value}
          readOnly
          className="w-full input-field bg-gray-50 pr-10 sm:pr-12 cursor-default select-all text-sm"
          onClick={(e) => e.currentTarget.select()}
        />
        <button
          type="button"
          onClick={handleCopy}
          className="absolute right-1.5 sm:right-2 top-1/2 -translate-y-1/2 p-1.5 sm:p-2 rounded-md hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-blue-500"
          title="Copy to clipboard"
          aria-label="Copy to clipboard"
        >
          {copied ? (
            <Check size={16} className="text-green-600 w-4 h-4" />
          ) : (
            <Copy size={16} className="text-gray-500 w-4 h-4" />
          )}
        </button>
      </div>
      {helperText && <p className="text-gray-500 text-xs mt-1">{helperText}</p>}
    </div>
  );
}
